import React from 'react';
import ArrowDropDownRoundedIcon from '@mui/icons-material/ArrowDropDownRounded';
import ArrowDropUpRoundedIcon from '@mui/icons-material/ArrowDropUpRounded';

const IconContainer: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div
    style={{
      background: '#42948c',
      borderRadius: '40px',
      height: '15px',
      width: '15px',
      position: 'relative',
    }}
  >
    {children}
  </div>
);

export const CustomSortIconDesc: React.FC = () => (
  <IconContainer>
    <ArrowDropDownRoundedIcon
      color="secondary"
      sx={{
        width: '15px',
        height: '15px',
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
      }}
    />
  </IconContainer>
);

export const CustomSortIconAsc: React.FC = () => (
  <IconContainer>
    <ArrowDropUpRoundedIcon
      color="secondary"
      sx={{
        width: '15px',
        height: '15px',
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
      }}
    />
  </IconContainer>
);

export const CustomSortIcon: React.FC = () => (
  <IconContainer>
    <ArrowDropUpRoundedIcon
      color="secondary"
      sx={{
        width: '15px',
        height: '15px',
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
      }}
    />
  </IconContainer>
);
